import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeCurrencyListItem extends SearchModelBase {
    inactive: boolean = false;
    userName: string = '';
    password: number|null = null;
    fromDecimal: number|null = null;
    toDecimal: number|null = null;
    bankinfo: string = '';
    id: number = 0;
    localSymbol: string = '';

    cid: string = '';
    cid2: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Currency', width: 100, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'Decimal Digit', width: 100, dataIndex: 'decimal', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 2, text: 'Symbol', width: 100, dataIndex: 'symbol'}),
        XCol.Create({ col: 3, text: 'Local Symbol', width: 100, dataIndex: 'localSymbol'}),
        XCol.Create({ col: 4, text: 'Inactive', width: 500, dataIndex: 'inactive', type: XCol.XCellType.Bool })
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeCurrencyListItem.prototype.code, orderByAscending: false };

    public static formatData(data: CodeCurrencyListItem[]) {
        return data.map((d: CodeCurrencyListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        decimal: {from: 'fromDecimal', to: 'toDecimal'},
    }
}
